// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/fontawesome/css/fontawesome.min.css
// module id = ij9U
// module chunks = 1